module.exports = __webpack_public_path__ + "img/Blocked.33fa9480.png";